import React, { useGlobal } from "reactn";
import PropTypes from "prop-types";
import AppHook from "../hooks/appHook";

const CollapseButton = ({ className }) => {

    // global state
    const [isCollapsed, setIsCollapsed] = useGlobal("isCollapsed");

    const { animateMainMargin } = AppHook();

    const handleClick = () => {
        !isCollapsed ? setIsCollapsed(true) : setIsCollapsed(false);
        animateMainMargin(isCollapsed);
    };

    return (
        <>
            <button className={className} type="button" onClick={() => handleClick()}>
                <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="5" transform="matrix(-1 0 0 1 48 0)" fill="#fff" fillOpacity=".1" />
                    <path d="m29 29-5-5 5-5m-5 10-5-5 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {!isCollapsed ? "Collapse" : ""}
            </button>
        </>
    );
};

export default CollapseButton;

CollapseButton.propTypes = {
    className: PropTypes.string,
};
